import {API, UNSPLASH_ACCESS_KEY} from "./utils";

const getSearchPhotos = () => (searchText, imageAmount) =>
  fetch(`${API}/search/photos?client_id=${UNSPLASH_ACCESS_KEY}&page=1&per_page=${imageAmount}&orientation=landscape&query=${searchText}`,
    {headers: {'Accept-Version': 'v1'}})
    .then(response => response.json())
    .then(json => json.results)

export default getSearchPhotos ;
